module.exports = __webpack_public_path__ + "img/battle_section5_item1.e0ded650.png";